import { useTranslation } from 'react-i18next'

import styles from './SubjectBlock.module.scss'

const SubjectBlock = ({
  subj,
  semIdx,
  subjIdx,
  moveItem,
  updateSubjects,
  updateThemes,
  setAddThemeOpen,
  removeSubject,
  removeTheme,
}) => {
  const { t } = useTranslation('common')

  return (
    <div className={styles.subject}>
      <div className={styles.subjectHeader}>
        <strong>{subj.name}</strong>
        <div className={styles.rowActions}>
          <button
            className="unv-btn unv-btn--ghost unv-btn--sm"
            onClick={() => updateSubjects(semIdx, (sb) => moveItem(sb, subjIdx, -1))}
          >
            {t('syllabus.up_btn')}
          </button>
          <button
            className="unv-btn unv-btn--ghost unv-btn--sm"
            onClick={() => updateSubjects(semIdx, (sb) => moveItem(sb, subjIdx, 1))}
          >
            {t('syllabus.down_btn')}
          </button>
          <button
            className="unv-btn unv-btn--ghost unv-btn--sm"
            onClick={() => setAddThemeOpen({ semesterIdx: semIdx, subjectIdx: subjIdx })}
          >
            {t('syllabus.add_theme_btn')}
          </button>
          <button
            className="unv-btn unv-btn--danger unv-btn--sm"
            onClick={() => removeSubject(semIdx, subjIdx)}
          >
            {t('syllabus.delete_btn')}
          </button>
        </div>
      </div>

      {(subj.themes || []).length > 0 && (
        <table className="unv-table">
          <thead>
            <tr>
              <th>{t('syllabus.col_theme')}</th>
              <th>{t('syllabus.col_hours')}</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {subj.themes.map((th, thIdx) => (
              <tr key={th.id || thIdx}>
                <td>{th.title}</td>
                <td>{th.hours}</td>
                <td>
                  <button
                    className="unv-btn unv-btn--ghost unv-btn--sm"
                    onClick={() =>
                      updateThemes(semIdx, subjIdx, (tt) => moveItem(tt, thIdx, -1))
                    }
                  >
                    ↑
                  </button>{' '}
                  <button
                    className="unv-btn unv-btn--ghost unv-btn--sm"
                    onClick={() =>
                      updateThemes(semIdx, subjIdx, (tt) => moveItem(tt, thIdx, 1))
                    }
                  >
                    ↓
                  </button>{' '}
                  <button
                    className="unv-btn unv-btn--danger unv-btn--sm"
                    onClick={() => removeTheme(semIdx, subjIdx, thIdx)}
                  >
                    {t('syllabus.delete_btn')}
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  )
}

export default SubjectBlock
